import React from 'react';
import classes from './style.module.scss';
const MenuItem = ({ name, composition, price }) => {
    return (
        <div className={classes.container}>
            <h3>{name}</h3>
            {composition && <p>{composition}</p>}
            <h4 className={classes.menuItemPrice}>{price}</h4>
        </div>
    );
};

export default MenuItem;
